module.exports = __webpack_public_path__ + "static/media/grillme_launcher_logo.7d3921b2.png";